// import ChangeLanguage from "../ChangeLanguage";
//PS : modifier menu list from bootdtrap to menu
//
//
import './Navbar.scss';

import { Close } from '@mui/icons-material';
//import { InputAdornment } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import MenuIcon from '@mui/icons-material/Menu';
import { Box, Chip, Collapse, Divider, Drawer, IconButton, List, ListItemButton, ListItemIcon, ListItemText ,ThemeProvider, useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';
import {NavDropdown } from 'react-bootstrap';
// import hthLogo from "../../../Assets/hth_logo.png";
import { Trans, useTranslation } from 'react-i18next';
import { Link, Outlet } from 'react-router-dom';

// import { Langue } from '../../../Contexts/lang/Langue';
import Logo from '../../../data/Logo';
import LogoLight from '../../../data/LogoLight';
import useWindowSize from '../../../hooks/useWindowSize';
import { FontLinkNavBar } from '../../../Styles/componentStyles';
import { navbarListConsultingHome } from '../SideBar/navListClient';

function NavbarConsulting() {
    const { t } = useTranslation();

    const { i18n } = useTranslation();
    const {device}=useWindowSize();
    const [ sideBarOpen, setSideBarOpen ] = useState(true);
    const theme = useTheme();
    const drawerWidthOpen = 267; //was 240 px
    const paddingIconButton = 10;
    const marginIconButton = 14;
    const iconFontSize = 20;
    const drawerWidthClose =
        (paddingIconButton + marginIconButton) * 2 + iconFontSize+10;
    //export var StateNa=['foo'];

    function toogleOpen() {
        setSideBarOpen(!sideBarOpen);
        //setNavBarOpen(!NavBarOpen);
        console.log(!sideBarOpen);
        if(!sideBarOpen){
            setOpenNestedItem1(false);
        }
        //console.log(LanguageContext);
    }
    console.log('device',device);
    const [openNestedItem1, setOpenNestedItem1] = useState([]);

    const drawerContent = (
        <>
            <Box
                sx={{
                    display: 'flex',
                    width: '267px',
                    backgroundColor: 'transparent',
                    padding: '24px 24px',
                    alignItems: 'flex-end',
                }}
            >
                <Box
                    sx={{
                        flexShrink: 0,
                        display: sideBarOpen ? 'none' : { xs: 'initial', sm: 'initial' },
                        //marginBottom: '9px',
                    }}
                >
                    <LogoLight />
                </Box>
                <IconButton
                    onClick={()=>{
                        setSideBarOpen(true);
                    }}
                    sx={{
                        minWidth: 'initial',
                        padding: '4px',
                        color: 'gray',
                        //borderRadius: '8px',
                        marginLeft:sideBarOpen ? '10px' : '70px',
                        backgroundColor: 'transparent',
                        '&:hover': {
                            backgroundColor: '#26284687',
                        },
                    }}
                >
                    <Close color={'white'}/>
                </IconButton>
            </Box>
            <List
                dense={true}
                sx={{
                    color: 'white !important',
                    paddingLeft: '10px',
                    marginTop: '-18px',
                    borderRadius: '8px',
                    '&:hover': {
                        color: 'red',
                    },
                }}
            >
                {navbarListConsultingHome.map((key, index) => (
                    <React.Fragment key={index}>
                        {/* //! Serach Item */}
                        <>
                            {/* <Tooltip
                            title={open ? key.desc : ''}
                            placement={'right'}
                            componentsProps={{
                                tooltip: {
                                    sx: {
                                        backgroundColor: 'gray',
                                        color: 'white',
                                        marginLeft: '22px !important',
                                        boxShadow: '0px 0px 22px -2px rgba(0,0,0,0.20)',
                                    },
                                },
                            }}
                            > */}
                            <ListItemButton
                                key={index}
                                onClick={() => {
                                    // ! here where I need to add more perfection, starts with all closed
                                    // handleClick1(index)
                                    setOpenNestedItem1({ [index]: !openNestedItem1[index] });
                                }}
                                sx={{
                                    margin: '6px 14px',
                                    color: 'white',
                                    fontSize: '15px',
                                    lineHeight: '24px',
                                    /* identical to box height, or 150% */
                                    letterSpacing: '-0.0044em',
                                    padding: '10px',
                                    borderRadius: '8px',
                                    '&:hover': {
                                        backgroundColor: '#26284687',
                                    },
                                }}
                            >
                                <ListItemIcon
                                    sx={{
                                        width:'22px',
                                        height:'19px',
                                        minWidth:sideBarOpen?'45px':'34px',
                                        fontFamily: 'Lato',
                                        fontStyle: 'normal',
                                        fontSize: '20px',
                                        lineHeight: '24px',
                                        /* identical to box height, or 150% */

                                        letterSpacing: '-0.0044em',
                                    }}
                                >
                                    {/*<Badge
                                        badgeContent={key.badge}
                                        color="secondary"
                                        variant="dot"
                                        sx={{
                                            width:'22px',
                                            height:'19px',
                                        }}
                                    >*/}
                                    <key.icon
                                        sx={{
                                            fontFamily: 'Lato',
                                            fontStyle: 'normal',
                                            fontWeight: '800',
                                            fontSize: '20px',
                                            lineHeight: '24px',
                                            /* identical to box height, or 150% */
                                            width:'22px',
                                            height:'19px',
                                            letterSpacing: '-0.0044em',
                                            color: 'white'
                                        }}
                                    />
                                    {/*</Badge>*/}
                                </ListItemIcon>
                                {
                                    key.subList.length == 0
                                        ?
                                        <Link
                                            to={`/${key?.link}`}
                                            style={{textDecoration:'none',
                                            }}
                                        >
                                            <ListItemText
                                                primaryTypographyProps={{
                                                    fontSize: '15px',
                                                    lineHeight: '24px',
                                                    letterSpacing: '-0.0044em',
                                                }}
                                                primary={
                                                    <ThemeProvider theme={FontLinkNavBar}>
                                                        <Typography variant='poster' >{key.desc}</Typography>
                                                    </ThemeProvider>
                                                }
                                                sx={{
                                                    display: 'inline',
                                                    margin: '0px',
                                                    overflowX: 'hidden',
                                                    color: 'white',
                                                    whiteSpace: 'nowrap',
                                                    minWidth: '126px',
                                                    letterSpacing: '-0.0044em',
                                                }}
                                            />
                                        </Link>
                                        :
                                        <ListItemText
                                            primary={key.desc}
                                            primaryTypographyProps={{
                                                fontSize: '15px',
                                                lineHeight: '24px',
                                                letterSpacing: '-0.0044em',
                                            }}
                                            sx={{
                                                display: 'inline',
                                                margin: '0px',
                                                overflowX: 'hidden',
                                                color: 'white',
                                                whiteSpace: 'nowrap',
                                                minWidth: '126px',
                                            }}
                                        />
                                }
                                {key.badge !== 0 ? (
                                    <Chip
                                        label={key.badge}
                                        color={'secondary'}
                                        size="small"
                                        sx={{ height: 'auto' }}
                                    />
                                ) : (
                                    <></>
                                )}
                                {key.subList.length > 0 ?
                                    (
                                        openNestedItem1[index]
                                            ?
                                            <>
                                                {/* <ExpandLess /> */}
                                                <KeyboardArrowUpIcon />
                                            </>
                                            :
                                            <>
                                                {/* <ExpandMore /> */}
                                                <KeyboardArrowDownIcon />
                                            </>
                                    )
                                    : (
                                        <></>
                                    )
                                }
                            </ListItemButton>
                            {
                                key.subList.length > 0 ?
                                    (
                                        key.subList.map((key, index1) => (
                                            <React.Fragment key={index1}>
                                                <Collapse
                                                    sx={{ color: 'white' }}
                                                    key={index1}
                                                    in={openNestedItem1[index]}   // : If true, the component will transition in.
                                                    timeout="auto"
                                                    unmountOnExit
                                                >
                                                    <List
                                                        component="div"
                                                        disablePadding
                                                    >
                                                        <ListItemButton
                                                            primaryTypographyProps={{
                                                                paddingTop:'0px',
                                                                paddingBottom:'0px',
                                                            }}
                                                            sx={{ pl: 4 }}
                                                        >
                                                            <Link
                                                                to={`/${key?.link}`}
                                                                style={{textDecoration:'none',
                                                                    fontWeight: '400',
                                                                    fontSize: '14px',
                                                                    //lineHeight: '20px',
                                                                    marginLeft:'27px',
                                                                    marginTop:'0px',
                                                                    marginBottom:'0px',
                                                                    padding:'0px',
                                                                    /* identical to box height, or 150% */
                                                                    color:'white',
                                                                    letterSpacing: '-0.0044em',
                                                                }}
                                                            >
                                                                <ListItemText
                                                                    primaryTypographyProps={{
                                                                        fontWeight: '400',
                                                                        fontSize: '14px',
                                                                        //lineHeight: '20px',
                                                                        marginTop:'0px',
                                                                        marginBottom:'0px',
                                                                        padding:'0px',
                                                                        fontStyle: 'normal',
                                                                        letterSpacing: '-0.0044em',
                                                                    }}
                                                                    sx={{ color: 'white !important'}}
                                                                    primary={key.desc}
                                                                />
                                                            </Link>
                                                        </ListItemButton>
                                                    </List>
                                                </Collapse>
                                            </React.Fragment>
                                        ))
                                    )
                                    :
                                    null
                            }
                        </>
                    </React.Fragment>
                ))}
                <Divider
                    variant="middle"
                    light={true}
                />
            </List>
        </>
    );
    return (
        <React.Fragment>
            {device=='desktop'?
                <div className='HomeNav'>
                    <div className='Titles'>
                        <div className='Logo1'>
                            <Link to="/">
                                <Logo
                                    width='102.78px'
                                    height= '28px'
                                />
                            </Link>
                        </div>
                        <div className='Titles2'>
                            <Link
                                to="/ConsultingServices"
                                className='titlesLink'
                            >
                                <Trans className='TitleStyle'>{i18n.t('Nos Services')}</Trans>
                            </Link>
                            <NavDropdown
                                title={t('A propos')}
                                id="nav-dropdown"
                                className='titlesLink'
                            >
                                <NavDropdown.Item >
                                    <Link
                                        to="/WhyHtHConsulting"
                                        className='titlesLink'
                                    >
                                        <Trans >{i18n.t('Pourquoi HTH')}</Trans>
                                    </Link>
                                </NavDropdown.Item>
                                <NavDropdown.Item>
                                    <Link
                                        to="/AboutUsConsulting"
                                        className='titlesLink'
                                    >
                                        <Trans>{i18n.t('Qui sommes nous')}</Trans>
                                    </Link>
                                </NavDropdown.Item>
                            </NavDropdown>
                            <Link
                                to="/Consultingblogs"
                                className='titlesLink'
                            >
                                <Trans className='TitleStyle'>{i18n.t('Blogs')}</Trans>
                            </Link>
                            {/* <Link
                                to="/ContactUs"
                                className='titlesLink'
                                style={{backgroundColor:'#001B99',borderRadius:'5px',padding:'6px',color:'white'}}
                            >
                                <Trans>{i18n.t('Contactez nous')}</Trans>
                            </Link> */}
                        </div>
                    </div>
                    <div className='Login'>
                        <Link
                            to="/ContactUs"
                            className='titlesLink'
                            style={{backgroundColor:'rgb(33, 77, 206)',borderRadius:'10px',padding:'10px',color:'white'}}
                        >
                            <Trans>{i18n.t('Contactez nous')}</Trans>
                        </Link>
                        {/* <div className='Btnlangue'>
                            <Langue />
                        </div> */}
                    </div>
                </div>
                :
                <div
                    className='HomeNav'
                    style={{padding:'17px 16px 17px 16px'}}
                >
                    {!sideBarOpen &&
                        <Box>
                            <Drawer
                                variant="permanent"
                                open={sideBarOpen}
                                sx={{
                                    fontFamily: 'Lato',
                                    fontStyle: 'normal',
                                    fontWeight: '400',
                                    fontSize: '14px',
                                    lineHeight: '24px',
                                    letterSpacing: '-0.0044em',
                                    width: sideBarOpen
                                        ? { xs: '0px', sm: '0px' }
                                        : { xs: drawerWidthClose, sm: drawerWidthOpen },
                                    transition: theme.transitions.create('width', {
                                        easing: theme.transitions.easing.sharp,
                                        duration: sideBarOpen
                                            ? theme.transitions.duration.leavingScreen
                                            : theme.transitions.duration.enteringScreen,
                                    }),
                                    '& .MuiDrawer-paper': {
                                        //justifyContent: 'space-between',
                                        //gap:'4px',
                                        fontFamily: 'Lato',
                                        fontStyle: 'normal',
                                        fontWeight: '400',
                                        fontSize: '14px',
                                        lineHeight: '24px',
                                        /* identical to box height, or 150% */
                                        letterSpacing: '-0.0044em',
                                        display:'flex',
                                        flexDirection: 'column',
                                        overflowX: 'hidden',
                                        width: sideBarOpen
                                            ? { xs: '0px', sm: device == 'desktop' ? drawerWidthClose : '0px' }
                                            : { xs: drawerWidthOpen, sm: drawerWidthOpen },
                                        // width: sideBarOpen
                                        //     ? { xs: '0px', sm: '0px' }
                                        //     :  { xs: drawerWidthClose, sm: drawerWidthOpen },
                                        borderRight: '0px',
                                        //borderRadius: '0px 14px 14px 0px',
                                        boxShadow: theme.shadows[8],
                                        backgroundColor: sideBarOpen ? '#214DCE' : '#214DCE',
                                        transition: theme.transitions.create('width', {
                                            easing: theme.transitions.easing.sharp,
                                            duration: sideBarOpen
                                                ? theme.transitions.duration.leavingScreen
                                                : theme.transitions.duration.enteringScreen,
                                        }),
                                    },
                                }}
                            >
                                {drawerContent}
                            </Drawer>
                        </Box>
                    }
                    {sideBarOpen &&
                        <div style={{display:'flex',flexDirection:'row',gap:'8px',alignItems:'left'}}>
                            <IconButton
                                onClick={toogleOpen}
                                sx={{
                                    padding: '4px',
                                    color: 'black',
                                    zIndex:'3000',
                                    backgroundColor: 'white',
                                    '&:hover': {
                                        backgroundColor: '#26284687',
                                    },
                                }}
                            >
                                <MenuIcon
                                    sx={{
                                        color:'balck',
                                        fontFamily: 'Lato',
                                        fontStyle: 'normal',
                                        fontWeight: '400',
                                        fontSize: '14px',
                                        lineHeight: '24px',
                                        height:'43px',
                                        width:'24px',
                                        /* identical to box height, or 150% */
                                        letterSpacing: '-0.0044em',
                                    }}
                                />
                            </IconButton>
                            <div className='LogoStyleNavBarGlobal'>
                                <Link to={'/'}>
                                    <Logo
                                        width='102px'
                                        height='46px'
                                    />
                                </Link>
                            </div>
                        </div>
                    }
                </div>
            }
            <Outlet />
        </React.Fragment>
    );
}
export default NavbarConsulting;